import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { colors, fontFamilies } from '../../../constants/theme';
import { figmaLetterSpacing } from '../../../ui/utils';

export const HeroSectionWrapper = styled(Box)(({ theme }) => ({
  color: '#4c2e1f',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

export const SectionHeading = styled('h2')(({ theme }) => ({
  fontFamily: fontFamilies?.gotham,
  textWrap: 'nowrap',
  color: colors.whiteText,
  fontWeight: 400,
  fontSize: '50px',
  lineHeight: '58px',
  letterSpacing: figmaLetterSpacing(50, -1),
  textAlign: 'center',
  [theme.breakpoints.down('lg')]: {
    fontSize: '42px',
    lineHeight: '50px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '23px',
    lineHeight: '32px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    lineHeight: '24px',
  },
}));
